/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Medme Marketing PRM API
 * API для автоматизированных маркетинговых рассылок и выгрузок (MedMe PRM).

**Разделы продукта:**
- **Рассылки** — отправка сообщений по сегменту (разово или по расписанию)
- **Выгрузки** — таблица пациентов по сегменту (файл, опционально e-mail с архивом)
- **Отчётность** — журнал запусков и доставки

**Авторизация:** HttpOnly cookie `token` (JWT), как в stats-api. Получение токена — через `GET /auth` stats-api.

**Контекст организации:** API работает с понятием «организация» — всем списком бизнесов, к которым у пользователя есть доступ. Сервер резолвит бизнесы автоматически из JWT-токена; `businessId` в query-параметрах не передаётся. Для операций над конкретным бизнесом (создание задачи, принятие условий) `businessId` передаётся в теле запроса.

 * OpenAPI spec version: 1.0.0
 */

/**
 * Состояние задачи (конфигурация, не результат запуска):
`draft` — черновик, не готов к запуску;
`active` — включена;
`paused` — приостановлена (для recurring обычно `active: false`).

 */
export type MarketingTaskStatus =
	(typeof MarketingTaskStatus)[keyof typeof MarketingTaskStatus]

export const MarketingTaskStatus = {
	draft: "draft",
	active: "active",
	paused: "paused",
} as const
